import React, { useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components'
import Header from './Header'
import Footer from './Footer'

const MainLayout = () => {
    const [showScrollTop, setShowScrollTop] = useState(false);

  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Show/hide scroll top button based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <TheMainLayout>
      <div className="header">
        <Header />
      </div>
      <div className="outlet">
        <Outlet />
      </div>
      <div className="footer">
        <Footer />
      </div>

      {/* Back to Top Button */}
      {showScrollTop && (
        <BackToTopButton
          onClick={scrollToTop}
          aria-label="Scroll to top"
          title="Back to top"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"
            />
          </svg>
        </BackToTopButton>
      )}
    </TheMainLayout>
  );
}

const TheMainLayout = styled.div`
  position: relative;
  width: 100%;
  height: fit-content;

  .outlet {
    min-height: 80vh;
  }
`;


const BackToTopButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #021a30 0%, #2c5282 100%);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(49, 130, 206, 0.3);
  z-index: 1000;
  transition: all 0.3s ease;
  opacity: 0.9;
  padding: 0;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(49, 130, 206, 0.4);
    opacity: 1;
  }

  &:active {
    transform: translateY(-1px);
  }

  svg {
    width: 20px;
    height: 20px;
    transition: transform 0.3s ease;
  }

  &:hover svg {
    transform: translateY(-2px);
  }

  /* Mobile styles */
  @media screen and (max-width: 900px) {
    width: 45px;
    height: 45px;
    bottom: 25px;
    right: 25px;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  @media screen and (max-width: 600px) {
    width: 40px;
    height: 40px;
    bottom: 20px;
    right: 20px;

    svg {
      width: 16px;
      height: 16px;
    }
  }

  @media screen and (max-width: 420px) {
    width: 35px;
    height: 35px;
    bottom: 15px;
    right: 15px;

    svg {
      width: 14px;
      height: 14px;
    }
  }

  @media screen and (max-width: 350px) {
    width: 32px;
    height: 32px;
    bottom: 12px;
    right: 12px;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;
export default MainLayout